import { Code as Key } from 'constants/keyboard';

import { TextWidgetTag } from '../common/TextBasedWidgets.types';

// Enter -> select all text for the text widget
const KEYBOARD_CONFIG = { excludeSpecific: [Key.Enter] };
const MAX_LETTER_SPACING = 800;
const MIN_LETTER_SPACING = -150;
const DEFAULT_CARET_COLOR = '#000000';

const TEXT_WIDGET_TAG_OPTIONS = [
  { value: TextWidgetTag.H1, label: 'h1', level: 1 },
  { value: TextWidgetTag.H2, label: 'h2', level: 2 },
  { value: TextWidgetTag.H3, label: 'h3', level: 3 },
  { value: TextWidgetTag.H4, label: 'h4', level: 4 },
  { value: TextWidgetTag.H5, label: 'h5', level: 5 },
  { value: TextWidgetTag.H6, label: 'h6', level: 6 },
  { value: TextWidgetTag.Paragraph, label: 'paragraph', level: '' },
];

export { KEYBOARD_CONFIG, TEXT_WIDGET_TAG_OPTIONS, MAX_LETTER_SPACING, MIN_LETTER_SPACING, DEFAULT_CARET_COLOR };
